export default __webpack_public_path__ + "static/EverydayInformationTwo-d8fb7cff5e841adf421a99deaf35ae05.webp";